import React, { useContext, useEffect, useState } from "react";
import { injectIntl } from "react-intl";

import { getEventTranslationKey } from "../../../Base/Utilities/TranslationHelper";
import { FixtureDetailsContext } from "../../../../Config/FixtureDetails.jsx";

const EventDetails = (props) => {
  const { currentState, intl, event } = props;
  const { formatMessage } = intl;
  const [detailsText, setDetailsText] = useState();
  const [team, setTeam] = useState();
  const [player, setPlayer] = useState();
  const [staff, setStaff] = useState();
  const { sport } = useContext(FixtureDetailsContext);

  const [eventDetails, setEventDetails] = useState();

  useEffect(() => {
    if (currentState && currentState.events && currentState.events[event]) {
      setEventDetails(currentState.events[event]);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!eventDetails) {
      return;
    }

    setTeam(
      currentState.entities.find(
        (el) => el.entityId === eventDetails.entityId
      )
    );

    setDetailsText(getEventTranslationKey(eventDetails, sport));
    // eslint-disable-next-line
  }, [eventDetails]);

  useEffect(() => {
    if (team) {
      setPlayer(
        team.persons.find((el) => el.personId === eventDetails.personId)
      );
      setStaff(
        team.staff.find((el) => el.personId === eventDetails.personId)
      );
    }
    // eslint-disable-next-line
  }, [team]);

  return (
    <div className="event">
      {detailsText && (
        <span className="event-type">
          <i
            className="fas fa-square"
            style={team && { color: team.primaryColor }}
          ></i>
          {formatMessage({
            id: detailsText,
            defaultMessage: detailsText,
          })}
        </span>
      )}
      {team && <span className="event-team">{team.fullNameLatin}</span>}
      {player && (
        <span className="event-player">
          <span>{player.bib}</span>
          <span>{player.name}</span>
        </span>
      )}
      {staff && (
        <span className="event-player">
          <span>{staff.name}</span>
        </span>
      )}
    </div>
  );
};

export default injectIntl(EventDetails);
